import useScript from '@/hooks/useScript';
import { OptimizelyFlags, useExperimentIsEnabled } from '@/services/experiments';

export const useCaptainBlogAI = () => {
  const captionBlogAIEnabled = useExperimentIsEnabled(OptimizelyFlags.CAPTAIN_BLOG_AI_ENABLED);

  const isMMINLoaded = useScript(
    captionBlogAIEnabled ? 'https://w.mmin.io/master-embed/v1.min.js' : undefined,
  );

  return isMMINLoaded;
};
